import * as actions from "./card.actions";
import * as api from "./card.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY } from "./card.constants";
import * as hooks from "./card.hooks";
import * as promises from "./card.promises";
import reducer from "./card.reducer";
import { saga } from "./card.saga";
import * as selectors from "./card.selectors";
import * as utils from "./card.utils";
export * from "./card.types";
export var REDUCER_KEY_CARD = REDUCER_KEY;
export var cardModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
    utils: utils,
};
